import Vue from 'vue';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/**
 *
 *  Uncomment the import and add the icon you need to the library.
 *
 * https://fontawesome.com/docs/web/use-with/vue/style
 */

/**
 *
 *  Free regular icons
 *
 */
// import { faCloudArrowUp as farCloudArrowUp } from '@fortawesome/free-regular-svg-icons';

/**
 *
 *  Free solid icons
 *
 */
import {
  faStar,
  faTrashCan,
  faRocket,
  faArrowRight,
  faCloudArrowUp,
  faRotateLeft,
  faRotateRight,
  faExclamation,
  faTriangleExclamation,
  faCircleExclamation,
  faInfo,
  faEye,
  faEyeSlash,
  faPause,
  faCircleInfo,
  faSpinner,
  faCalendar,
  faUserGroup,
  faCircleCheck,
  faXmark,
  faExternalLinkAlt,
  faCaretDown,
  faCaretUp,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';

/**
 *
 *  Free brand icons
 *
 */
// import {  } from "@fortawesome/free-brands-svg-icons";

config.autoAddCss = false;

library.add(
  faRocket,
  faArrowRight,
  faCloudArrowUp,
  faTrashCan,
  faStar,
  faRotateLeft,
  faRotateRight,
  faExclamation,
  faTriangleExclamation,
  faCircleExclamation,
  faEye,
  faEyeSlash,
  faPause,
  faInfo,
  faCircleInfo,
  faSpinner,
  faCalendar,
  faUserGroup,
  faCircleCheck,
  faXmark,
  faExternalLinkAlt,
  faCaretDown,
  faCaretUp,
  faCheck
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
